import React from 'react'
import {
  LuBrainCircuit,
  LuClock3,
  LuMicVocal,
  LuSparkles,
  LuVolume2,
} from 'react-icons/lu'
import memoryObservatory from '../../assets/resources/memory-observatory-octopus.webp'
import octopusMark from '../../assets/home/octopus-mark.png'

const waveBars = [8, 15, 24, 13, 29, 18, 33, 20, 26, 12, 22, 9]

const TipsMemoryVisual = () => (
  <div className="tips-hero__art" aria-hidden="true">
    <div className="tips-memory__backdrop">
      <img
        className="tips-memory__image"
        src={memoryObservatory}
        alt=""
        width="1672"
        height="941"
        fetchPriority="high"
      />
      <img
        className="tips-memory__ambient"
        src={memoryObservatory}
        alt=""
        width="1672"
        height="941"
      />
      <span className="tips-memory__shade" />
      <span className="tips-memory__sheen" />
    </div>

    <svg
      className="tips-memory__network"
      viewBox="0 0 1180 520"
      preserveAspectRatio="none"
      focusable="false"
    >
      <defs>
        <linearGradient id="tips-memory-route" x1="0" y1="0" x2="1" y2="0">
          <stop offset="0" stopColor="#7edfff" stopOpacity=".2" />
          <stop offset=".64" stopColor="#7edfff" stopOpacity=".78" />
          <stop offset="1" stopColor="#ffd88e" stopOpacity=".95" />
        </linearGradient>
      </defs>
      <g className="tips-memory__routes">
        <path d="M676 132 C756 142 814 190 885 250" pathLength="1" />
        <path d="M1041 124 C980 159 936 203 890 250" pathLength="1" />
        <path d="M710 405 C774 360 830 298 885 250" pathLength="1" />
        <path d="M1040 400 C975 350 928 294 890 250" pathLength="1" />
      </g>
      <g className="tips-memory__nodes">
        <circle cx="676" cy="132" r="4" />
        <circle cx="1041" cy="124" r="4" />
        <circle cx="710" cy="405" r="4" />
        <circle cx="1040" cy="400" r="4" />
        <circle className="tips-memory__node-core" cx="890" cy="250" r="7" />
      </g>
    </svg>

    <span className="tips-memory__packet tips-memory__packet--one" />
    <span className="tips-memory__packet tips-memory__packet--two" />
    <span className="tips-memory__packet tips-memory__packet--three" />

    <div className="tips-memory__status">
      <i />
      <span><span lang="fr">Mémoire en réveil</span><small lang="en">Memory reawakening</small></span>
    </div>

    <div className="tips-memory__cue tips-memory__cue--recall">
      <LuBrainCircuit />
      <span><span lang="fr">Rappel actif</span><small lang="en">Active recall</small></span>
    </div>

    <div className="tips-memory__cue tips-memory__cue--rhythm">
      <LuClock3 />
      <span><span lang="fr">5 minutes suffisent</span><small lang="en">5 minutes are enough</small></span>
    </div>

    <div className="tips-memory__cue tips-memory__cue--voice">
      <LuMicVocal />
      <span><span lang="fr">Parlez tôt</span><small lang="en">Speak early</small></span>
    </div>

    <div className="tips-memory__prompt">
      <div className="tips-memory__prompt-topline">
        <LuSparkles />
        <span><span lang="fr">Pratique du jour</span><small lang="en">Today’s practice</small></span>
        <small className="tips-memory__prompt-time">5 min</small>
      </div>
      <strong>
        <span lang="fr">« Décrivez votre matinée. »</span>
        <small lang="en">“Describe your morning.”</small>
      </strong>
      <div className="tips-memory__wave">
        {waveBars.map((height, index) => (
          <i key={`${height}-${index}`} style={{ '--wave-height': `${height}px`, '--wave-index': index }} />
        ))}
      </div>
      <div className="tips-memory__prompt-foot">
        <LuVolume2 />
        <span><span lang="fr">Écoutez · Répondez · Progressez</span><small lang="en">Listen · Respond · Progress</small></span>
      </div>
    </div>

    {Array.from({ length: 9 }, (_, index) => (
      <i className={`tips-memory__mote tips-memory__mote--${index + 1}`} key={index} />
    ))}
  </div>
)

const TipsMemorySeed = ({ className = '' }) => (
  <div className={`${className} tips-memory-seed`.trim()} aria-hidden="true">
    <span className="tips-memory-seed__orbit tips-memory-seed__orbit--one" />
    <span className="tips-memory-seed__orbit tips-memory-seed__orbit--two" />
    <span className="tips-memory-seed__core">
      <img src={octopusMark} alt="" width="160" height="160" decoding="async" />
    </span>
    <i className="tips-memory-seed__signal" />
  </div>
)

export { TipsMemorySeed }
export default TipsMemoryVisual
